<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'tripulanteCrud'"
          crudName="Tripulantes"
          newText="Novo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "tripulantesTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "tripulante_id",
        "tripulante_nome",
        "tripulante_cpf",
        "tripulante_email",
        "tripulante_celular",
        "tripulante_status",
        "embarque_ativo",
        "usuario",
        "actions",
      ],
      tableData: [
        "tripulante_id",
        "tripulante_nome",
        "tripulante_cpf",
        "tripulante_email",
        "tripulante_celular",
        "tripulante_status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "tripulante_id",
          "tripulante_nome",
          "tripulante_email",
          "tripulante_celular",
          "tripulante_status",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          tripulante_id: "ID",
          tripulante_nome: "Nome do Tripulante",
          tripulante_status: "Status",
          embarque_ativo: "Quantidades de Embarque Ativo",
          actions: "Ações",
        },
        sortable: ["tripulante_id", "tripulante_nome", "tripulante_status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          tripulante_status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
        },
        templates: {
          usuario: function (h, row, index) {
            return row.usuario ? row.usuario.usuario_nome : "";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["usuario"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "tripulantes",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        tripulante_id: "tripulante_id",
        tripulante_nome: "tripulante_nome",
        tripulante_cpf: "tripulante_cpf",
        tripulante_email: "tripulante_email",
        tripulante_celular: "tripulante_celular",
        tripulante_status: "tripulante_status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>